/* ======================================================================
   Bundle Builder — Custom Enhancements (no CSS)
   Safe to include on product pages; all logic is guard-railed.
   Note: Black Friday banner is now in black-friday-banner.js (loaded globally)
   ====================================================================== */

/* -------------------- tiny helpers -------------------- */
const $  = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

/* ======================================================================
   0) Add Product Subheadline
   ====================================================================== */
(function addProductSubheadline() {
  document.addEventListener('DOMContentLoaded', () => {
    const productTitle = $('.product__title');
    if (!productTitle) return;

    // Check if subheadline already exists
    if (document.querySelector('.product-subheadline')) return;

    // Create subheadline element
    const subheadline = document.createElement('div');
    subheadline.className = 'product-subheadline';
    subheadline.innerHTML = '100% Natural Lentil Mixes • Ready in 20 Minutes • 5 Meals Per Jar';

    // Insert after the product title
    productTitle.insertAdjacentElement('afterend', subheadline);
  });
})();

/* ======================================================================
   1) Add Rotating Reviews
   ====================================================================== */
(function addRotatingReviews() {
  document.addEventListener('DOMContentLoaded', () => {
    // Find the social proof badge
    const socialProofBadge = $('.tlh-rating.as-badge');
    if (!socialProofBadge) return;

    // Check if reviews already exist
    if (document.querySelector('.tlh-rotating-reviews')) return;

    // Create reviews container
    const reviewsContainer = document.createElement('div');
    reviewsContainer.className = 'tlh-rotating-reviews';
    reviewsContainer.innerHTML = `
      <div class="swiper featured-review-swiper" style="margin: 0.5rem 0 0;">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div style="background: #fffbe9; border-left: 4px solid #f4a300; border-radius: 6px; padding: 0.75rem 1rem; margin: 0.35rem 0;">
              <blockquote style="font-style: italic; font-size: 0.85rem; line-height: 1.4; margin: 0 0 0.4rem; color: #222;">
                "Absolutely delicious and so easy to make! This mix has become a staple in my weekly meals."
              </blockquote>
              <div style="font-weight: 600; font-size: 0.8rem; color: #111;">
                – Jessica K.
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div style="background: #fffbe9; border-left: 4px solid #f4a300; border-radius: 6px; padding: 0.75rem 1rem; margin: 0.35rem 0;">
              <blockquote style="font-style: italic; font-size: 0.85rem; line-height: 1.4; margin: 0 0 0.4rem; color: #222;">
                "I never thought lentils could be this tasty. I now look forward to weekday dinners!"
              </blockquote>
              <div style="font-weight: 600; font-size: 0.8rem; color: #111;">
                – Christine M.
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div style="background: #fffbe9; border-left: 4px solid #f4a300; border-radius: 6px; padding: 0.75rem 1rem; margin: 0.35rem 0;">
              <blockquote style="font-style: italic; font-size: 0.85rem; line-height: 1.4; margin: 0 0 0.4rem; color: #222;">
                "These lentils are a total game changer — quick, healthy, and so flavorful!"
              </blockquote>
              <div style="font-weight: 600; font-size: 0.8rem; color: #111;">
                – Ronald L.
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination" style="text-align:center;margin-top:0.5rem;"></div>
      </div>
    `;

    // Insert after social proof badge
    socialProofBadge.insertAdjacentElement('afterend', reviewsContainer);

    // Initialize Swiper if available
    if (window.Swiper) {
      new Swiper('.featured-review-swiper', {
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
      // Force white background via inline style to beat any !important CSS overrides
      const swiperEl = document.querySelector('.featured-review-swiper');
      if (swiperEl) {
        swiperEl.style.setProperty('background', '#fff', 'important');
        swiperEl.style.setProperty('border-left', 'none', 'important');
      }
    }
  });
})();

/* ======================================================================
   2) Add Hero CTA Button
   ====================================================================== */
(function addHeroCTA() {
  document.addEventListener('DOMContentLoaded', () => {
    // Find the rotating reviews container
    const reviewsContainer = $('.tlh-rotating-reviews');
    if (!reviewsContainer) return;

    // Check if CTA already exists
    if (document.querySelector('.tlh-hero-cta')) return;

    // Create CTA button
    const ctaButton = document.createElement('a');
    ctaButton.className = 'tlh-hero-cta';
    ctaButton.href = '#bundle-section';
    ctaButton.textContent = 'Start Building - Save Up to $16 + FREE Shipping';

    // Create social proof badge
    const socialProof = document.createElement('div');
    socialProof.className = 'hero-social-proof';
    socialProof.innerHTML = '🔥 <strong>800+ Orders This Week</strong> | ⭐ <strong>4.86/5</strong> (1,000+ Reviews) | ✅ <strong>30-Day Money-Back Guarantee</strong>';

    // Create sticky CTA (hidden by default)
    const stickyCTA = document.createElement('a');
    stickyCTA.className = 'tlh-hero-cta tlh-hero-cta-sticky';
    stickyCTA.href = '#bundle-section';
    stickyCTA.textContent = 'Start Building - Save Up to $16 + FREE Shipping';
    stickyCTA.style.display = 'none';
    document.body.appendChild(stickyCTA);

    // Shared scroll handler
    function handleCTAClick(e) {
      e.preventDefault();

      // Try multiple possible selectors for the bundle builder
      const bundleSection = document.getElementById('bundle-section')
        || document.querySelector('.gbbProductBuilder')
        || document.querySelector('[data-app-name="easy-bundle-builder"]')
        || document.getElementById('tlh-qs');

      if (bundleSection) {
        const yOffset = -120; // Offset for header
        const y = window.pageYOffset + bundleSection.getBoundingClientRect().top + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      } else {
        // Fallback: scroll to a reasonable position if bundle section not found
        window.scrollTo({ top: 800, behavior: 'smooth' });
      }
    }

    // Add smooth scroll behavior to both buttons
    ctaButton.addEventListener('click', handleCTAClick);
    stickyCTA.addEventListener('click', handleCTAClick);

    // Insert after rotating reviews
    reviewsContainer.insertAdjacentElement('afterend', ctaButton);
    ctaButton.insertAdjacentElement('afterend', socialProof);

    // Show/hide sticky CTA based on scroll position
    let ticking = false;
    function handleScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const rect = ctaButton.getBoundingClientRect();
          const isCtaOutOfView = rect.bottom < 0;

          // Check if bundle section is in view
          const bundleSection = document.querySelector('.gbbMultipleCategoriesPageHTML, .gbbProductBuilder, [data-app-name="easy-bundle-builder"]');
          let isBundleInView = false;
          if (bundleSection) {
            const bundleRect = bundleSection.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            // Consider bundle in view if any part of it is visible in viewport
            isBundleInView = bundleRect.top < windowHeight && bundleRect.bottom > 0;
          }

          // Show sticky CTA only if original is out of view AND bundle is not in view
          if (isCtaOutOfView && !isBundleInView) {
            stickyCTA.style.display = 'block';
            // Trigger animation
            requestAnimationFrame(() => {
              stickyCTA.classList.add('visible');
            });
          } else {
            stickyCTA.classList.remove('visible');
            // Wait for animation to complete before hiding
            setTimeout(() => {
              if (!stickyCTA.classList.contains('visible')) {
                stickyCTA.style.display = 'none';
              }
            }, 300);
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    // Check initial state
    handleScroll();
  });
})();

/* ======================================================================
   4) Add No List Section After Bundle Builder
   ====================================================================== */
(function addNoList() {
  document.addEventListener('DOMContentLoaded', () => {
    // Wait for bundle builder to be present
    const checkBundleBuilder = setInterval(() => {
      const bundleBuilder = document.querySelector('.gbbPageBody')
        || document.querySelector('.gbbProductBuilder')
        || document.querySelector('[data-app-name="easy-bundle-builder"]')
        || document.querySelector('#tlh-bundle-builder')
        || document.querySelector('.tlh-bundle-builder-section');

      if (bundleBuilder) {
        clearInterval(checkBundleBuilder);

        // Skip on bundle-template-d
        if (document.body.classList.contains('template-product-bundle-template-d')) return;

        // Check if No List already exists
        if (document.querySelector('.no-list-section')) return;

        // Create No List section
        const noListSection = document.createElement('div');
        noListSection.className = 'no-list-section';
        noListSection.innerHTML = `
          <div class="no-list-content">
            <img src="https://cdn.shopify.com/s/files/1/0557/6055/2035/files/Orange_and_Yellow_Minimalistic_Modern_Event_For_This_Week_Instagram_Post_2300_x_2500_px.svg?v=1762794045" alt="The No List" class="no-list-full-image" loading="lazy">
          </div>
        `;

        // Insert after Complete Your Bundle section if it exists, otherwise after bundle builder
        const insertionPoint = document.querySelector('.complete-bundle-section') || bundleBuilder;
        insertionPoint.insertAdjacentElement('afterend', noListSection);
      }
    }, 100);

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkBundleBuilder), 10000);
  });
})();

/* ======================================================================
   4) Add FAQ Section Before Judge.me Reviews Section
   ====================================================================== */
(function addFAQSection() {
  document.addEventListener('DOMContentLoaded', () => {
    // Wait for the shopify section before Judge.me reviews
    const checkAnchor = setInterval(() => {
      const reviewsSection = document.querySelector('[id*="1729535912bc292e2d"]')
        || document.querySelector('.shopify-section.mount-app');

      if (reviewsSection) {
        clearInterval(checkAnchor);

        // Check if FAQ already exists
        if (document.querySelector('.faq-section')) return;

        // Create FAQ section
        const faqSection = document.createElement('div');
        faqSection.className = 'faq-section';
        faqSection.innerHTML = `
          <h2 class="faq-title">FAQS</h2>
          <div class="faq-content">
            <div class="faq-item">
              <button class="faq-question">
                <span>Are your Lentils Gluten-free?</span>
                <span class="faq-toggle">+</span>
              </button>
              <div class="faq-answer">
                <p>Yes, Lentils are naturally gluten-free. Please note that some ingredients come from shared facilities.</p>
              </div>
            </div>

            <div class="faq-item">
              <button class="faq-question">
                <span>Where can I find the nutrition facts?</span>
                <span class="faq-toggle">+</span>
              </button>
              <div class="faq-answer">
                <p>Each Product page has detailed information on Nutrition facts, including on the photo carousel.</p>
              </div>
            </div>

            <div class="faq-item">
              <button class="faq-question">
                <span>Are there no added salt / no sodium options available?</span>
                <span class="faq-toggle">+</span>
              </button>
              <div class="faq-answer">
                <p>Yes. Simply let us know while placing your order that you would like this option. You can include this note in "Order Instructions" on the shopping cart or shoot us an email at <a href="mailto:help@thelentilhub.com" style="color: #0066cc; text-decoration: underline;">help@thelentilhub.com</a></p>
              </div>
            </div>

            <div class="faq-item">
              <button class="faq-question">
                <span>How long after placing the order will I recieve my shipment?</span>
                <span class="faq-toggle">+</span>
              </button>
              <div class="faq-answer">
                <p>Most Orders are shipped within 24 hours. Actual delivery times vary by destination but most orders are delivered in 5-7 days.</p>
              </div>
            </div>

            <div class="faq-item">
              <button class="faq-question">
                <span>Which locations do you ship to?</span>
                <span class="faq-toggle">+</span>
              </button>
              <div class="faq-answer">
                <p>We ship within the Continental United States and now also to Alaska and Hawaii (by popular demand 😊).</p>
              </div>
            </div>
          </div>
        `;

        // Insert before reviews section
        reviewsSection.insertAdjacentElement('beforebegin', faqSection);

        // Add click handlers for accordion functionality
        const faqQuestions = faqSection.querySelectorAll('.faq-question');
        faqQuestions.forEach(question => {
          question.addEventListener('click', () => {
            const faqItem = question.parentElement;
            const isOpen = faqItem.classList.contains('active');

            // Close all other FAQs
            faqSection.querySelectorAll('.faq-item').forEach(item => {
              item.classList.remove('active');
              item.querySelector('.faq-toggle').textContent = '+';
            });

            // Toggle current FAQ
            if (!isOpen) {
              faqItem.classList.add('active');
              question.querySelector('.faq-toggle').textContent = '×';
            }
          });
        });
      }
    }, 100);

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkAnchor), 10000);
  });
})();

/* ======================================================================
   5) Add Contact CTA After FAQ
   ====================================================================== */
(function addContactCTA() {
  document.addEventListener('DOMContentLoaded', () => {
    // Wait for FAQ section to be present
    const checkFAQ = setInterval(() => {
      const faqSection = document.querySelector('.faq-section');

      if (faqSection) {
        clearInterval(checkFAQ);

        // Skip on bundle-template-d
        if (document.body.classList.contains('template-product-bundle-template-d')) return;

        // Check if Contact CTA already exists
        if (document.querySelector('.contact-cta-section')) return;

        // Create Contact CTA section
        const contactSection = document.createElement('div');
        contactSection.className = 'contact-cta-section';
        contactSection.innerHTML = `
          <h2 class="contact-cta-heading">Still have a question? Contact us for answers</h2>
          <a href="/pages/contact" class="contact-cta-button">CONTACT US</a>
        `;

        // Insert after FAQ
        faqSection.insertAdjacentElement('afterend', contactSection);
      }
    }, 100);

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkFAQ), 10000);
  });
})();

/* Format money using Shopify if available */
const fmt = (n) => {
  try { if (window.Shopify?.formatMoney) return Shopify.formatMoney(Math.round(n * 100)); } catch (e) {}
  if (window.Shopify?.currency?.symbol) return Shopify.currency.symbol + n.toFixed(2);
  return '$' + n.toFixed(2);
};

/* Parse numeric from text (prices like "$65.00") */
const num = (t) => {
  const v = parseFloat(String(t || '').replace(/[^0-9.,]/g, '').replace(/,/g, ''));
  return isNaN(v) ? 0 : v;
};


/* ======================================================================
   1) Smooth scroll from any "Buy Now" CTA to the bundle widget
   ====================================================================== */
(function attachScrollToBundle() {
  document.addEventListener('DOMContentLoaded', () => {
    $$('a.btn-premium-cta').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const widget = $('#tlh-bundle-builder') || $('#bundle-section');
        if (!widget) return;
        e.preventDefault();
        const rect = widget.getBoundingClientRect();
        const targetY = window.pageYOffset + rect.top - 50; // headroom
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      });
    });
  });
})();

/* ======================================================================
   2) First-order banner - DISABLED for custom builder
   (Can be re-enabled if needed in the new design)
   ====================================================================== */
// Banner disabled - not needed with new bundle builder design

/* ======================================================================
   3) Small "value note" under TOTAL+ATC (5 meals/jar line)
   ====================================================================== */
(function mountBundleValueNote() {
  const NOTE_ID   = 'tlh-meal-note';
  const NOTE_TEXT = '5 meals / jar — just $2.6 per meal';

  function attachNote() {
    const footer = $('.tlh-bundle-summary');
    if (!footer) return;

    const actionContainer = footer.querySelector('.tlh-add-to-cart-btn');
    if (!actionContainer) return;

    let note = document.getElementById(NOTE_ID);
    if (!note) {
      note = document.createElement('div');
      note.id = NOTE_ID;
      note.className = 'bundle-value-note';
      note.style.cssText = 'text-align: center; margin-top: 0.75rem; color: #666; font-size: 0.9rem; font-weight: 600;';
      note.textContent = NOTE_TEXT;
    }
    if (actionContainer.nextElementSibling !== note) {
      actionContainer.insertAdjacentElement('afterend', note);
    }
  }

  // Listen for bundle updates
  document.addEventListener('tlh:bundle:updated', () => {
    setTimeout(attachNote, 50);
  });

  let tries = 0;
  (function boot() {
    attachNote();
    if (!document.getElementById(NOTE_ID) && tries++ < 60) setTimeout(boot, 200);
  })();
})();

/* ======================================================================
   4) Free shipping tracker for bundle footer
   ====================================================================== */
(function freeShippingTracker() {
  const FREE_SHIP = 65;

  function ensureMounted() {
    const container = $('#tlh-free-shipping-tracker');
    if (!container) return null;

    let tracker = container.querySelector('.free-ship-tracker');
    if (!tracker) {
      tracker = document.createElement('div');
      tracker.className = 'free-ship-tracker';
      tracker.innerHTML = `
        <div class="fst-row fst-combined">
          <div class="fst-sub"></div>
          <div class="fst-bar"><div class="fst-fill" style="width:0%"></div></div>
        </div>
      `;
      container.appendChild(tracker);
    }
    return tracker;
  }

  function render(totals) {
    const tracker = ensureMounted();
    if (!tracker) return;

    const sub = tracker.querySelector('.fst-sub');
    const bar = tracker.querySelector('.fst-fill');

    const total = totals.total / 100; // Convert cents to dollars
    const progress = Math.min((total / FREE_SHIP) * 100, 100);
    const remaining = Math.max(FREE_SHIP - total, 0);

    // Update progress bar
    if (bar) {
      bar.style.width = `${progress}%`;
    }

    // Update messaging
    if (total >= FREE_SHIP) {
      // Free shipping unlocked - check if they can get bundle discount
      if (totals.itemCount >= 6) {
        // Already getting bundle discount
        sub.innerHTML = `🚚 <strong>FREE SHIPPING</strong> + <strong>Bundle Discount</strong> active!`;
      } else if (totals.itemCount === 5) {
        // Encourage them to add one more for discount
        sub.innerHTML = `🚚 <strong>FREE SHIPPING</strong> unlocked! Add 1 more jar to unlock <strong>bundle discount</strong>`;
      } else {
        // 1-4 items but somehow over $65 (edge case)
        sub.innerHTML = `🚚 <strong>FREE SHIPPING</strong> unlocked!`;
      }
    } else if (total > 0) {
      sub.innerHTML = `Add $${remaining.toFixed(2)} more for <strong>free shipping</strong>`;
    } else {
      sub.innerHTML = `Add items to unlock <strong>free shipping</strong> at <strong>$${FREE_SHIP}+</strong>`;
    }
  }

  // Listen for bundle updates
  document.addEventListener('tlh:bundle:updated', (e) => {
    render(e.detail.totals);
  });

  // Initialize
  let tries = 0;
  (function boot() {
    const container = $('#tlh-free-shipping-tracker');
    if (container) {
      ensureMounted();
    } else if (tries++ < 60) {
      setTimeout(boot, 200);
    }
  })();
})();

/* ======================================================================
   5) Best-selling bundle helpers - UPDATED for custom builder
   ====================================================================== */
// Best-selling bundle functionality is now handled by the Quick Start
// presets in the custom bundle builder (Family Favorites preset)

// Global helper: how many items are currently in the bundle
function getBundleItemCount(){
  if (window.TLHBundleBuilder) {
    const state = window.TLHBundleBuilder.getState();
    return state.totals.itemCount;
  }
  return 0;
}

// Clear bundle (uses new API)
async function clickClearIfAny(){
  const hasItems = getBundleItemCount() > 0;
  if (!hasItems) return false;

  if (window.TLHBundleBuilder) {
    window.TLHBundleBuilder.clearBundle();
    await sleep(220);
    return true;
  }
  return false;
}

// Ensure bundle is empty before proceeding
async function clearBundleAndWait(maxMs = 6000){
  await clickClearIfAny();
  const deadline = Date.now() + maxMs;
  while (getBundleItemCount() > 0 && Date.now() < deadline){
    await sleep(150);
  }
}


// Spice badges are now built into the custom bundle builder
// No separate initialization needed!

/* ======================================================================
   6) Quick Start header - UPDATED for custom builder
   ====================================================================== */
(function () {
  // ---- tiny helpers ----
  const $  = (s, r=document)=>r.querySelector(s);
  const $$ = (s, r=document)=>Array.from(r.querySelectorAll(s));
  const sleep = (ms)=>new Promise(r=>setTimeout(r, ms));

  // Prefer your global toast if present; else local fallback
  function localToast(msg = "Great choice! Bundle loaded! 🎉") {
    const existing = document.querySelector(".tlh-toast");
    if (existing) existing.remove();
    const el = document.createElement("div");
    el.className = "tlh-toast show";
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(() => { el.classList.remove("show"); setTimeout(() => el.remove(), 400); }, 3000);
  }
  const toast = (msg) => (typeof window.showBundleToast === 'function' ? window.showBundleToast(msg) : localToast(msg));

  // Track currently active preset key globally
  let activePresetKey = null;

  // ---------- UI ----------
  function pillStyle(btn, active){
    if (active){
      btn.style.background = '#000';
      btn.style.color = '#fff';
      btn.style.border = '1px solid #000';
    } else {
      btn.style.background = '#fff';
      btn.style.color = '#111';
      btn.style.border = '1px solid #e5e5e5';
    }
    btn.style.borderRadius = '9999px';
    btn.style.padding = '6px 12px';
    btn.style.fontWeight = '600';
    btn.style.display = 'inline-flex';
    btn.style.alignItems = 'center';
    btn.style.gap = '6px';
    btn.style.cursor = 'pointer';
    btn.style.whiteSpace = 'nowrap';
  }

  function buildUI(){
    const wrap = document.createElement('div');
    wrap.id = 'tlh-qs';
    wrap.className = 'tlh-qs-wrap';
    wrap.innerHTML = `
      <h2 class="tlh-bundle-header">Build Your Perfect Meal Bundle</h2>
      <div class="bf-countdown-timer">
        <div class="bf-countdown-label">🔥 BLACK FRIDAY ENDS IN:</div>
        <div class="bf-countdown-display">
          <div class="bf-time-unit">
            <span class="bf-time-value" id="bf-days">0</span>
            <span class="bf-time-label">Days</span>
          </div>
          <div class="bf-time-unit">
            <span class="bf-time-value" id="bf-hours">0</span>
            <span class="bf-time-label">Hours</span>
          </div>
          <div class="bf-time-unit">
            <span class="bf-time-value" id="bf-minutes">0</span>
            <span class="bf-time-label">Minutes</span>
          </div>
          <div class="bf-time-unit">
            <span class="bf-time-value" id="bf-seconds">0</span>
            <span class="bf-time-label">Seconds</span>
          </div>
        </div>
      </div>
      <div class="tlh-qs-row tlh-qs-benefits premium">
        <span class="benefit"><span class="icon">🚚</span><span class="label">5 jars: <strong>FREE</strong> shipping <strong>(save $10+)</strong></span></span>
        <span class="benefit"><span class="icon">💰</span><span class="label">6+ jars: Just $12/jar + <strong>FREE</strong> shipping <strong>(save $16+)</strong></span></span>
        <span class="benefit"><span class="icon">🍚</span><span class="label"><strong>5</strong> meals / jar</span></span>
      </div>
      <div class="tlh-qs-row tlh-qs-inline">
        <span class="tlh-qs-label">Quick start: Our best bundles for you 👉</span>
        <div class="tlh-qs-pills" role="tablist" aria-label="Quick start bundles">
          <button class="qs-pill" data-key="variety" role="tab" data-shopify-track="false">
            <span class="i">🧡</span> Variety Sampler
            <span style="font-size: 10px; opacity: 0.6; font-weight: 500; margin-left: 5px; text-transform: uppercase; letter-spacing: 0.3px; vertical-align: middle;">Best Value</span>
          </button>
          <button class="qs-pill" data-key="family"  role="tab" data-shopify-track="false">
            <span class="i">🥄</span> Family Favorites
          </button>
        </div>
        <a href="#" class="tlh-qs-help-link" data-action="scroll-to-help" style="font-size: 12px; color: #666; text-decoration: underline; margin-left: 12px; white-space: nowrap;">Need help deciding?</a>
      </div>
    `;

    // initial styling - apply active state if there's a stored key
    $$('.qs-pill', wrap).forEach(b => {
      const isActive = activePresetKey && b.dataset.key === activePresetKey;
      pillStyle(b, isActive);
      if (isActive) b.classList.add('is-active');
    });

    // click handling — uses new bundle builder API
    let qsBusy = false;

    wrap.addEventListener('click', async (e) => {
      const btn = e.target.closest('.qs-pill');
      if (!btn || qsBusy) return;

      if (!window.TLHBundleBuilder) {
        toast('Bundle builder not ready yet. Please wait...');
        return;
      }

      qsBusy = true;
      window.isPresetLoading = true;
      document.body.style.cursor = 'wait';

      // Store the active preset key
      activePresetKey = btn.dataset.key;

      // Clear any previously active pill and highlight the new one
      clearActive();
      setActive(btn);

      // Use the new API to load the preset
      window.TLHBundleBuilder.loadPreset(btn.dataset.key);

      // Re-apply active state after everything is done
      await sleep(500);
      const currentBtn = $(`.qs-pill[data-key="${activePresetKey}"]`);
      if (currentBtn) setActive(currentBtn);

      document.body.style.cursor = 'default';
      window.isPresetLoading = false;
      qsBusy = false;
    });

    // Handle "Need help deciding?" link
    const helpLink = wrap.querySelector('[data-action="scroll-to-help"]');
    if (helpLink) {
      helpLink.addEventListener('click', (e) => {
        e.preventDefault();
        // Look for the soup mixes comparison table (Premixes_trans.png)
        const helpImage = document.querySelector('img[src*="Premixes_trans"]');
        const helpSection = helpImage ? helpImage.closest('.shopify-section, section, .image-section') :
                           document.querySelector('#shopify-section-image_cUFttb, [id*="image_cUFttb"]');

        if (helpSection || helpImage) {
          (helpSection || helpImage).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    return wrap;
  }

  function setActive(btn){
    $$('.qs-pill').forEach(b => {
      const active = (b === btn);
      b.classList.toggle('is-active', active);
      pillStyle(b, active);
    });
  }
  function clearActive(){
    $$('.qs-pill').forEach(b => {
      b.classList.remove('is-active');
      pillStyle(b, false);
    });
  }

  // Mount before the bundle builder products
  function mountUI(){
    if ($('#tlh-qs')) return true;
    const builder = $('#tlh-bundle-builder');
    if (!builder) return false;

    const productsGrid = $('.tlh-products-grid', builder);
    if (!productsGrid) return false;

    productsGrid.insertAdjacentElement('beforebegin', buildUI());

    // Initialize countdown timer after mounting
    initCountdown();

    return true;
  }

  // Countdown timer function
  function initCountdown() {
    function updateCountdown() {
      const daysEl = document.getElementById('bf-days');
      const hoursEl = document.getElementById('bf-hours');
      const minutesEl = document.getElementById('bf-minutes');
      const secondsEl = document.getElementById('bf-seconds');

      // Guard: elements must exist
      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

      const endDate = new Date('2025-11-29T23:59:59').getTime();
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance < 0) {
        daysEl.textContent = '0';
        hoursEl.textContent = '0';
        minutesEl.textContent = '0';
        secondsEl.textContent = '0';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysEl.textContent = days;
      hoursEl.textContent = hours;
      minutesEl.textContent = minutes;
      secondsEl.textContent = seconds;
    }

    // Update immediately and then every second
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  // Listen for bundle updates to manage active state
  document.addEventListener('tlh:bundle:updated', (e) => {
    const itemCount = e.detail.totals.itemCount;
    // Only clear active state if bundle is empty AND we're not loading a preset
    if (itemCount === 0 && !window.isPresetLoading) {
      activePresetKey = null;
      clearActive();
    } else if (activePresetKey && itemCount > 0) {
      // Re-apply active state if we have a stored key and items in bundle
      const btn = $(`.qs-pill[data-key="${activePresetKey}"]`);
      if (btn) setActive(btn);
    }
  });

  // Boot with retries until the bundle builder appears
  let tries = 0;
  (function boot(){
    const mounted = mountUI();
    if (!mounted && tries++ < 150) setTimeout(boot, 200);
  })();
})();


/* ------------------ Toast notification for bundle added ------------------ */
function showBundleToast(msg = "Great choice! Added selected bundle to cart 🎉") {
  // Avoid duplicate toasts
  if (document.querySelector(".tlh-toast")) return;

  const toast = document.createElement("div");
  toast.className = "tlh-toast";
  toast.innerHTML = msg;
  document.body.appendChild(toast);

  // Trigger fade-in
  requestAnimationFrame(() => toast.classList.add("show"));

  // Auto-remove after 3 seconds
  setTimeout(() => {
    toast.classList.remove("show");
    setTimeout(() => toast.remove(), 500);
  }, 3000);
}
